import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export function AffordablePackages() {
  const scrollToBooking = () => {
    document.getElementById('booking-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="pricing" className="bg-[#FFC4D0] py-24 px-4 md:px-8" data-id="element-14">
      <div className="container mx-auto" data-id="element-15">
        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-16">
          <div className="md:w-1/2" data-id="element-17">
            <h2 className="text-5xl md:text-6xl font-bold mb-6 text-[#1a1a1a]" data-id="element-18">
              Affordable Messages
            </h2>
            <p className="text-lg text-gray-800 mb-8" data-id="element-19">
              Simple, transparent pricing for your event. Everything you need is
              included.
            </p>

            <div className="bg-white p-8 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-20">
              <div className="absolute top-0 right-0 bg-black text-white px-4 py-2 rounded-bl-xl font-bold text-sm" data-id="element-21">
                MOST POPULAR
              </div>

              <h3 className="text-3xl font-bold mb-2" data-id="element-22">Full Weekend</h3>
              <div className="flex items-baseline mb-6" data-id="element-23">
                <span className="text-5xl font-bold" data-id="element-24">$299</span>
                <span className="text-gray-500 ml-2" data-id="element-25">/ event</span>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-26">
                {['Vintage Rotary Phone Rental', 'Unlimited Voicemails', 'Personalized Greeting Setup', 'Digital Audio Files Delivery', 'Free Return Shipping', 'Audio Processing & Cleanup'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-27">
                    <div className="w-6 h-6 rounded-full bg-[#FFB5C5] flex items-center justify-center flex-shrink-0" data-id="element-28">
                      <Check className="w-4 h-4 text-black" data-id="element-29" />
                    </div>
                    <span data-id="element-30">{item}</span>
                  </li>)}
              </ul>

              <Button variant="black" className="w-full" onClick={scrollToBooking} data-id="element-31">
                Book This Package
              </Button>
            </div>
          </div>

          <div className="md:w-1/2" data-id="element-32">
            <div className="relative" data-id="element-33">
              <img src="https://cdn.magicpatterns.com/uploads/xtSbE4WEYSWzABbFkgfjAz/pasted-image.jpg" alt="Bride using audio guest book" className="rounded-3xl shadow-2xl w-full object-cover h-[600px]" data-id="element-34" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-3xl flex flex-col justify-end p-8 text-white" data-id="element-35">
                <p className="font-['Caveat'] text-3xl mb-2" data-id="element-36">
                  "Best decision we made!"
                </p>
                <p className="text-sm opacity-80" data-id="element-37">
                  Listening to the messages the next day was pure magic.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}